module.exports["output"] = "_JiraSynchronization__output";
module.exports["rotating"] = "_JiraSynchronization__rotating";